import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AppLayout from "./components/AppLayout";
import StockManagement from "./components/StockManagement";
import Orders from "./components/Orders";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Layout Route wrapping protected pages */}
        <Route element={<AppLayout />}>
          <Route path="/stock" element={<StockManagement />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/" element={<Navigate to="/stock" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
